module.exports = __webpack_public_path__ + "img/ny.821bfec1.svg";